import { render, staticRenderFns } from "./publicationsTutorial.vue?vue&type=template&id=7347663c&scoped=true"
import script from "./publicationsTutorial.vue?vue&type=script&lang=js"
export * from "./publicationsTutorial.vue?vue&type=script&lang=js"
import style0 from "./publicationsTutorial.vue?vue&type=style&index=0&id=7347663c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7347663c",
  null
  
)

export default component.exports